import Vue from 'vue'
import Vuex from 'vuex'
import userInfo from './modules/userInfo'
import imCommunication from './modules/imCommunication'
import bigScreenZrtc from './modules/bigScreenZrtc'
import switchingSchool from './modules/switchingSchool'
import inspectionTour from './modules/inspectionTour'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    userInfo,
    imCommunication,
    bigScreenZrtc,
    switchingSchool,
    inspectionTour
  }
})
